module.exports = __webpack_public_path__ + "static/media/kivalo.f38c5f50.png";